export default __webpack_public_path__ + "ai-aware.35905857.png";